import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

function ErrorBoundary({ children }: { children: React.ReactNode }) {
  const [hasError, setHasError] = React.useState(false);
  const [error, setError] = React.useState<Error | null>(null);

  React.useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      console.error('Global error caught:', event.error);
      setError(event.error);
      setHasError(true);
    };

    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  if (hasError) {
    return (
      <div style={{ 
        padding: '20px', 
        backgroundColor: 'lightcoral', 
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h1>🚨 JavaScript Error Detected</h1>
        <p><strong>Error:</strong> {error?.message || 'Unknown error'}</p>
        <p><strong>Stack:</strong></p>
        <pre style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px' }}>
          {error?.stack || 'No stack trace available'}
        </pre>
        <button 
          onClick={() => window.location.reload()} 
          style={{ padding: '10px 20px', marginTop: '10px' }}
        >
          Reload Page
        </button>
      </div>
    );
  }

  return <>{children}</>;
}

// Force cache clear by adding timestamp
console.log("🔄 App loading at:", new Date().toISOString());

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
